import e from "./defineProperty.js";
//#region \0@oxc-project+runtime@0.151.0/helpers/esm/objectSpread2.js
function t(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function n(n) {
	for (var r = 1; r < arguments.length; r++) {
		var i = arguments[r] == null ? {} : arguments[r];
		r % 2 ? t(Object(i), !0).forEach(function(t) {
			e(n, t, i[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(e) {
			Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(i, e));
		});
	}
	return n;
}
//#endregion
export { n as default };
